import {useEffect, useState} from 'react';
import {setFullLoading} from '../../store/appSlice';
import {useDispatch} from 'react-redux';
import {Col, Row} from 'react-bootstrap';
import {apiGet, apiPost} from '../../apis/index';
import {useMsal} from '@azure/msal-react';
import {MdArrowBackIosNew} from 'react-icons/md';
import {useNavigate} from 'react-router-dom';
import {trackPromise} from 'react-promise-tracker';
import Swal from 'sweetalert2';

const MaintenanceSetting = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {instance, accounts} = useMsal();
  const [startDateInput, setStartDateInput] = useState();
  const [endDateInput, setEndDateInput] = useState();

  useEffect(() => {
    trackPromise(
        (async () => {
          try {
            dispatch(setFullLoading(true));

            const json = await apiGet({
              uri: `Maintainance/Status`,
              msal: {
                instance: instance,
                accounts: accounts,
              },
            });

            setStartDateInput(json?.disableModeStart || '');
            setEndDateInput(json?.disableModeEnd || '');
            dispatch(setFullLoading(false));
          } catch (error) {
            dispatch(setFullLoading(true));
            console.error('queryFn error', error);
          }
        })(),
    );
  }, [instance, accounts, dispatch]);

  const submit = async ()=>{
    try {
      if (!startDateInput || !endDateInput) return;

      await apiPost({
        uri: `Maintainance/config`,
        msal: {
          instance: instance,
          accounts: accounts,
        },
        payload: {
          'disableModeStart': startDateInput,
          'disableModeEnd': endDateInput,
        },
      });

      Swal.fire({
        title: 'Updated!',
        icon: 'success',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } catch (error) {

    }
  };

  return (
    <>

      <div className='mb-4 pointer d-flex align-items-center'>
        <div onClick={() => navigate('/back-office/settings')}>
          <MdArrowBackIosNew size={'20px'} />
          <span className='ms-2'>Settings / Maintenance Settings</span>
        </div>
      </div>

      <div className='custom-card px-5 py-5 mb-5 mt-2 w-50' style={{margin: '0 auto'}}>
        <div className="mb-3 ">
          <label htmlFor="exampleInputEmail1" className="form-label">Start Date</label>
          <input type="datetime-local" className="form-control" id="exampleInputEmail1" value={startDateInput} onChange={(e) => setStartDateInput(e.target.value)} />
        </div>

        <div className="mb-3">
          <label htmlFor="exampleInputEmail2" className="form-label">End Date</label>
          <input type="datetime-local" className="form-control" id="exampleInputEmail2" value={endDateInput} onChange={(e) => setEndDateInput(e.target.value)}/>
        </div>

        <Row>
          <Col xs={6}></Col>
          <Col xs={6}>
            <div className='admin-btn admin-btn-primary d-flex align-items-center justify-content-center mt-3' style={{cursor: 'pointer'}}
              onClick={submit}
            >
          Update
            </div>
          </Col>
        </Row>
      </div>

    </>
  );
};

export default MaintenanceSetting;
